import React, {useState} from 'react';
import './style.css';

const ToggleBar = ({formName, options, onSelectAction = () => {}}) => {
    const handleChange = (e) => {
        const selectedValue = e.target.value;
        onSelectAction(selectedValue); // ✅ Pass only selected value
    };

    return (
        <div id="toggle-bar-container">
            <select
                onChange={handleChange}
                className="select-dropdown"
                name={formName || "togglebar"}
            >
                {options.map((option, index) => (
                    <option key={index} value={option.value}>{option.label}</option>
                ))}
            </select>
        </div>
    );
};

export { ToggleBar };
